// Non-secret client-side hint that an authenticated session exists. The HttpOnly
// cookie remains the credential — this flag is the signal that lets us tell
// "401 because the session expired" apart from "401 because the user never had
// a session at all" (visiting /signin while logged out). Without this hint,
// every fresh visitor to /signin gets a spurious "Session expired" toast, because
// the refresh path can't distinguish the two cases.
//
// Industry-standard pattern (Google's LSID, Facebook's c_user, etc.). NOT a
// credential; safe to keep in localStorage.

const SESSION_PRESENCE_KEY = 'mightybot:hasSession';

const readStorage = (): Storage | null => {
	try {
		return typeof window !== 'undefined' ? window.localStorage : null;
	} catch {
		return null;
	}
};

export const markSessionEstablished = (): void => {
	readStorage()?.setItem(SESSION_PRESENCE_KEY, '1');
};

export const markSessionEnded = (): void => {
	readStorage()?.removeItem(SESSION_PRESENCE_KEY);
};

export const hasSessionHint = (): boolean => {
	return readStorage()?.getItem(SESSION_PRESENCE_KEY) === '1';
};
